import { getUserRoles } from '../../../services/AuthServices'

// @FAC-26753: khớp với AuthMiddleware.hasRoles ở 3d-api (các route ghi /partners: tạo, sửa, xoá, hiện lại)
const PARTNER_MANAGER_ROLES = ['fac_admin', 'Super Admin']

export const DISABLED_ICON_STYLE = { opacity: 0.4, cursor: 'not-allowed' }

export const canManagePartner = () => getUserRoles().some(role => PARTNER_MANAGER_ROLES.includes(role.name))

export const getNoPermissionMessage = (action) => `Bạn không có quyền ${action} đối tác.`

// action: 'tạo' | 'sửa' | 'xoá' | 'hiện lại'
export const getPartnerErrorMessage = (error, action) => {
    const { response } = error || {}
    if (response && response.status === 403) return getNoPermissionMessage(action)

    return (error && error.message) || 'Đã có lỗi xảy ra, vui lòng thử lại.'
}
